import React from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';

import Alert from '@front/web-ui/src/components/alert/alert';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

export const ErrorContainer = styled.div`
  width: 100%;
  margin-bottom: ${toRem(10)};
`;

type ErrorsProps = {
  errors?: string[];
};

export const Errors = ({ errors = [] }: ErrorsProps) =>
  errors.length > 0 ? (
    <ErrorContainer>
      <Alert type='error' content={errors} />
    </ErrorContainer>
  ) : null;

// Forms
export const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
